var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsLikeIcon = function SvgDsLikeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.823 1.059A.67.67 0 0 1 7.43.667c.712 0 1.398.278 1.905.777.507.5.794 1.179.794 1.89v2h3.164a2.04 2.04 0 0 1 1.54.683 2 2 0 0 1 .477 1.618l-.935 6c-.074.48-.32.915-.693 1.226-.37.31-.84.477-1.324.472h-9.67a2.03 2.03 0 0 1-1.425-.582 2 2 0 0 1-.596-1.418V8.667c0-.534.215-1.044.596-1.418.38-.374.892-.582 1.425-.582H4.29zm-2.77 6.94H2.689a.7.7 0 0 0-.49.2.66.66 0 0 0-.198.468v4.666c0 .174.07.342.198.468a.7.7 0 0 0 .49.199h1.366zm1.334 6h6.982a.7.7 0 0 0 .458-.161.66.66 0 0 0 .23-.406l.935-6a.65.65 0 0 0-.157-.532.69.69 0 0 0-.531-.233H9.462A.667.667 0 0 1 8.796 6V3.333c0-.35-.142-.688-.397-.939a1.4 1.4 0 0 0-.565-.334L5.387 7.477z",
    clipRule: "evenodd"
  })));
};
export default SvgDsLikeIcon;